
import Vue from 'vue'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import UserInfo from '@/components/UserInfo.vue'

export default Vue.extend({
  name: 'App',
  components: { Breadcrumbs, UserInfo },
  methods: {
    login() {
      this.$auth.loginWithRedirect()
    }
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        const { companyId, folderId } = params

        if (companyId) {
          this.$store.dispatch('GET_FOLDERS', companyId)
        }
        if (folderId) {
          this.$store.dispatch('GET_TECHPACKS', { id: folderId, company: companyId })
        }
      },
      deep: true,
      immediate: true
    }
  }
})
